export const ContentHeader =
    "The USA's #1 booking website for activities, tours, and things to do. Browse reviews, deals, photos and more from over 1,000+ experiences. Low price guarantee on every booking.";

export const ALL_EXPERIENCES = 'All Experiences';
export const ALL_COMPANIES = 'All Companies';
